import * as React from 'react';

import * as styles from './styles.css';

interface IErrorProps {
  handleClick(): void;
}

export const Error: React.FC<IErrorProps> = props => {
  return (
    <div className={styles['container']}>
      Не получилось загрузить данные.
      <br />
      Попробуйте{' '}
      <button className={styles['pseudolink']} onClick={props.handleClick}>
        обновить страницу
      </button>
      , либо зайдите позже
    </div>
  );
};

Error.displayName = 'Error';
